'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _manager = require('../styles/manager');

var _theme = require('../styles/theme');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var PropTypes = Object.assign({
  deprecate: function () {
    function deprecate(propType, message) {
      if (process.env.NODE_ENV === 'production') return propType;

      var _warn = function () {
        function warn(props, propName, displayName) {
          if (!props[propName]) return;
          console.warn('Deprecation:', message || 'Deprecation: Prop \'' + displayName + '.' + propName + '\' is no longer used.');
          _warn = function () {
            function warn() {}

            return warn;
          }();
        }

        return warn;
      }();

      return function (props, propName, displayName) {
        _warn(props, propName, displayName);
        return propType.apply(this, arguments);
      };
    }

    return deprecate;
  }(),
  styleManager: _propTypes2['default'].instanceOf(_manager.StyleManager),
  theme: _propTypes2['default'].instanceOf(_theme.Theme),
  origin: _propTypes2['default'].shape({
    vertical: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].func, _propTypes2['default'].oneOf(['top', 'center', 'bottom'])]),
    horizontal: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].func, _propTypes2['default'].oneOf(['left', 'center', 'right'])])
  }),
  childrenOfComponentType: function () {
    function childrenOfComponentType(expectedComponent) {
      return function (props, propName, componentName) {
        var error = null;
        _react2['default'].Children.forEach(props[propName], function (child) {
          if (!error && child.type !== expectedComponent) {
            var expectedName = expectedComponent.name;
            error = new Error('Invalid prop ' + propName + ' supplied to ' + componentName + '. Expected ' + (expectedName ? '"' + expectedName + '"' : 'a different') + ' component type.');
          }
        });
        return error;
      };
    }

    return childrenOfComponentType;
  }()
}, _propTypes2['default']);

exports['default'] = PropTypes;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/utils/PropTypes.js
// module id = 3
// module chunks = 32